export default function List(opts){
    let container = opts.container
    let _station = opts.station
    let element = undefined
    this.generate = () =>{
        prepareContainer()
        //gerando elementos(ListItem) baseados na lista de postos
        generateListItems()
        //inserindo elementos como lista no container
        generateList()
        // console.log(stations_list);
    }
    /**
     * Filtra a lista de Postos baseado nos parâmetros passados.
     * Lista apenas a exibição na lista de postos, não no mapa. Isso quem controla é o filtro principal do produto
     * Leva tbm em consideração se o posto está valido no filtro geral, em caso negativo, ele também é removido da lista de postos.
     * @param {Array} Lista de parametros. ex: [['name', 'posto1'],['prefix', '4c-001']]
     */
    this.filter = (params) =>{
        _station.list.forEach(station=>{

            //verificando se o posto está filtrado pelo filtro principal
            if(station.show){
                let validations = [];
                
                params.forEach(param=>{
                    let value = param[1]
                    
                    if(param[0] == 'selected'){
                        validations.push(station.listItem.isSelected() == value)
                    } else {
                        let field = station[param[0]]
                        validations.push(field.toLowerCase().indexOf(value.toString().toLowerCase()) != -1)
                    }                    
                })                
                station.listItem.setShow(!validations.includes(false))
            }
            
        })
    }
    /**
     * Limpa container e gera a lista de postos
     */
    function generateList(){
        $(element).html('')
        _station.list.forEach(station=>{
            if(station.show){
                let listItem = station.listItem
                $(element).append(listItem.getElement())
            }
        })
    }

    //esconde/exibe os items na lista de acordo com o parametro 'show' do objeto station
    this.reload = _=>{
        _station.list.forEach(station=>{
            
            //parametro 'show' dentro do listItem controla se ele aparece ou nao. Fazendo que ele seja igual o do filtro geral
            station.listItem.setShow(station.show)
        })
    }

    //remove todas as seleções da lista/mapa. Utilizando o campo 'selected' do objeto Station
    this.selectAll = (boolean = false) =>{
        _station.list.map(station=>{
            if(station.selected != boolean){station.selected = boolean}
        })
        return true
    }

    /**
     * Gera um ListItem para cada posto e salva no próprio objeto do posto.
     * Não acopla no container, o método 'generateList' faz isso
     */
    function generateListItems(){
        _station.list.forEach((station, index) => {
            //criando para facilitar usabilidade
            station.complete_name = station.prefix + " - " + station.name
            
            //item para adicionar na lista
            let listItem = new ListItem({station: station, show:true})
            
            //salvando listItem dentro do objeto representativo do posto (HUGE para controle)
            station.listItem = listItem

            station._selected = function(){
                station.listItem.isSelected()
            } 
        });
    }


    /**
     * Objeto ListItem, contem parametros e métodos para controle dos items da lista de postos do componente
     * Poderia ser em outro arquivo, mas né..
     * @param {Hash} opts 
     */
    function ListItem(opts){
        let station = opts.station
        let name=station.name
        let prefix = station.prefix
        let value = station.id
        let complete_name = station.complete_name
        let element = undefined
        
        let state = {
            selected: _ => station.selected,
            show: opts.show
        }
        let stateV = {
            context: this,
            get(obj, key){
                return obj[key]
            },
            set(obj, key, value){
                obj[key] = value
                if(key == 'selected'){
                    // this.context.updateStyle()
                    // this.context.updateIcon()
                }
                if(key == 'show'){
                    // exibir/esconder elemento
                    this.context.showHandler()
                }
                return true
            }
        }

        this.state = new Proxy(state, stateV)

        this.getElement = ()=>{
            return element
        }
        this.getName =()=>{
            return name
        }
        this.getValue =()=>{
            return value
        }
        this.update = () =>{
            element.innerHTML = generateHTML.call(this) 
        }
        this.updateIcon = () =>{
            $(this.getElement()).find('.icon').html(generateIcon.call(this))
        }
        //altera o status de exibição do item
        //com ajuda do Proxy, acaba também escondendo/exibindo o elemento HTML na lista
        this.setShow = boolean =>{
            this.state.show = boolean
        }

        this.showHandler = () =>{
            if(this.state.show){
                $(element).removeClass("hide")
            } else {
                $(element).addClass('hide')
            }
        }

        this.updateStyle = () =>{
            if(this.isSelected()){
                $(this.getElement()).addClass('active')
            } else {
                $(this.getElement()).removeClass('active')
            }
            
        }
        this.update = ()=>{
            this.updateStyle()
            this.updateIcon()
        }

        this.isSelected = () =>{
            return this.state.selected()
        }

        function generateHTML(){
            return "<div class='btn-find-container'><i class='far fa-eye btn-find'></i></div><div class='item'><div class='text'>"+complete_name+"</div><div class='icon'>"+generateIcon.call(this)+"</div></div>"
        }

        function generateIcon(){
            if(this.isSelected()){
                return '<i class="fas fa-check-square text-white"></i>'
            } else {
                return ""
            }
        }
        initialize.call(this)

        function initialize(){
            element = document.createElement("div");
            element.classList.add("list-item")
            element.innerHTML = generateHTML.call(this)
            $(element).find('.item').on('click', ()=>{
                $(document).trigger("station_list:item_click", {item:this})
            })
            $(element).find('.btn-find-container').on('click', ()=>{                
                $(document).trigger("map:zoom_to_marker", {station_prefix_id:value})
            })
        }
    }

    function prepareContainer(){
        $(container).html("<div class='offcanvas-stations-list offcanvas-stations-list-wrapper pretty-scrollbar'></div>")
        element = $(container).find('.offcanvas-stations-list-wrapper')
    }
}